import { defineStore } from "pinia"
import { ProjectRentalDispenseItem } from "@/models/project-rental-dispense-item.model"
import { ref, type Ref } from "vue"
import { usePriceAgreementsConstantTimeLookup } from "@/composables/store/price-agreements-constant-time-lookup"

export const useProjectsRentalDispenseItemsStore = defineStore(
  "projectsRentalDispenseItemsStore",
  () => {
    const projectsRentalDispenseItems: Ref<ProjectRentalDispenseItem[]> = ref([])

    const { getPriceAgreement, getUnitPrice } =
      usePriceAgreementsConstantTimeLookup<ProjectRentalDispenseItem>(
        projectsRentalDispenseItems,
        (item) => [item.project, item.rentalDispenseItem],
        (item) => item.unitPricePerDay
      )

    return {
      projectsRentalDispenseItems,
      getPriceAgreement,
      getUnitPrice
    }
  }
)
